import React from 'react';
import T from 'prop-types';
import { Alert } from 'antd';
import upperFirst from 'lodash.upperfirst';

const UpgradeSuccessfulAlert = ({ isVisible, plan }) => {
  if (!isVisible) {
    return null;
  }

  const message = 'Payment successful';
  const description = `You are now on the ${upperFirst(plan)} plan.`;

  return <Alert description={description} message={message} showIcon type="success" />;
};

UpgradeSuccessfulAlert.propTypes = {
  isVisible: T.bool.isRequired,
  plan: T.string.isRequired,
};

export default UpgradeSuccessfulAlert;
